import { setupWorker } from 'msw'
import handlers from './handlers'

export const startMswServer = async () => {
  if (global?.window?.Cypress) {
    const worker = setupWorker(...handlers)
    worker.start()
  }
}
